import React, { createContext, useContext, useEffect, useState } from "react";
import { resolveSiteImages } from "../lib/db";
const SiteImagesContext = createContext({});
export function SiteImagesProvider({ children }) {
  const [images, setImages] = useState({});
  const [loading, setLoading] = useState(true);
  const refresh = async () => {
    try {
      const data = await resolveSiteImages();
      setImages(data);
    } catch {}
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    refresh();
  }, []);
  return (
    <SiteImagesContext.Provider value={{ images, refresh, loading }}>{children}</SiteImagesContext.Provider>
  );
}
export const useSiteImages = () => useContext(SiteImagesContext);
export const useSiteImage = (key, fallback = "") => {
  const { images, loading } = useSiteImages();
  if (loading) return null;
  return images?.[key] || fallback;
};
